var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66667V13.3333H2.66667V2.66667H16ZM17.3333 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390525C0.140476 0.640573 0 0.979711 0 1.33333V14.6667C0 15.0203 0.140476 15.3594 0.390524 15.6095C0.640573 15.8595 0.979711 16 1.33333 16H17.3333C17.687 16 18.0261 15.8595 18.2761 15.6095C18.5262 15.3594 18.6667 15.0203 18.6667 14.6667V10L24 15.3333V0.666667L18.6667 6V1.33333C18.6667 0.979711 18.5262 0.640573 18.2761 0.390525C18.0261 0.140476 17.687 0 17.3333 0Z",
    fill: "#213c92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostVideoIcon);
export default __webpack_public_path__ + "static/media/post-video-icon.023a2c2a19becd759f0b26bb38574e72.svg";
export { ForwardRef as ReactComponent };